import React from "react";
import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { Compass, Newspaper, ArrowRight } from "lucide-react";

export default function NotFound() {
  return (
    <>
      <Seo
        title="Not found"
        description="The page you were looking for could not be found. Browse our latest arbitration coverage or weekly digest instead."
        path="/404"
        noIndex
      />
      <div className="max-w-3xl mx-auto px-6 py-24 text-center" data-testid="not-found-page">
        <div className="eyebrow" style={{ color: "#EF4444" }}>404 · Off the docket</div>
        <h1 className="font-serif text-5xl md:text-6xl mt-3 text-[var(--io-text)]">
          We couldn't find that page
        </h1>
        <p className="mt-4 text-[var(--io-text-2)] text-[15px] max-w-xl mx-auto">
          The article may have been moved, the slug renamed, or the link mistyped.
          Try one of the destinations below — or jump straight back to the command center.
        </p>

        <div className="mt-10 grid sm:grid-cols-3 gap-3 text-left">
          <Link to="/" className="io-card-el p-4 hover:border-[var(--io-gold)] transition-colors group" data-testid="not-found-home">
            <Compass size={16} className="text-[var(--io-gold)]"/>
            <div className="mt-2 font-serif text-[18px] text-[var(--io-text)]">Home</div>
            <div className="text-[12px] font-mono text-[var(--io-muted)] mt-1 flex items-center gap-1">Latest signals <ArrowRight size={12} className="group-hover:translate-x-0.5 transition-transform"/></div>
          </Link>
          <Link to="/latest" className="io-card-el p-4 hover:border-[var(--io-gold)] transition-colors group" data-testid="not-found-latest">
            <Newspaper size={16} className="text-[var(--io-gold)]"/>
            <div className="mt-2 font-serif text-[18px] text-[var(--io-text)]">All latest</div>
            <div className="text-[12px] font-mono text-[var(--io-muted)] mt-1 flex items-center gap-1">Full feed <ArrowRight size={12} className="group-hover:translate-x-0.5 transition-transform"/></div>
          </Link>
          <Link to="/digest" className="io-card-el p-4 hover:border-[var(--io-gold)] transition-colors group" data-testid="not-found-digest">
            <Newspaper size={16} className="text-[var(--io-gold)]"/>
            <div className="mt-2 font-serif text-[18px] text-[var(--io-text)]">Friday digest</div>
            <div className="text-[12px] font-mono text-[var(--io-muted)] mt-1 flex items-center gap-1">Weekly brief <ArrowRight size={12} className="group-hover:translate-x-0.5 transition-transform"/></div>
          </Link>
        </div>
      </div>
    </>
  );
}
